var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.href ? 'a' : 'button',{tag:"div",staticClass:"button",class:_vm.getFieldClasses,attrs:{"href":!!_vm.href ? _vm.href : false,"type":!!!_vm.href ? _vm.type : false,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }